export default __webpack_public_path__ + "static/media/cop28-uae.249600b9.jpg";